interface Props {
  value: number;     // 0..1
  height?: number;
  className?: string;
}

export function ProgressBar({ value, height = 4, className = '' }: Props) {
  const v = Math.max(0, Math.min(1, value));
  return (
    <div className={`w-full bg-text/10 rounded-pill overflow-hidden ${className}`} style={{ height }}>
      <div
        className="h-full bg-accent transition-[width] duration-slow rounded-pill"
        style={{ width: `${v * 100}%` }}
      />
    </div>
  );
}
